import React, { useState } from 'react';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { useOffboardPopupContext } from '../../../context/OffboardPopupContext';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

export default function OffboardForAdmins() {
  const navigate = useNavigate();
  const location = useLocation();
  const [roleBasedOffboardSection] = useState(null);
  const [isModalForAcceptingTerms, setModalForAcceptingTerms] = useState(false);
  const { toggleExitPopup } = useOffboardPopupContext();

  const breadcrumbTrail = [
  { name: 'admin', path: '/admin/dashboard' },
  { name: 'Offboarded', path: '/admin/offboarded' },
  { name: 'ScheduleMeeting', path: '/admin/offboarded/schedule-meeting' }
];

  return (
    <div className='container-fluid'>
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse" }}>
        <div className="icons-list">
          {location.pathname === "/admin/offboarded" && <Breadcrumb />}
          {roleBasedOffboardSection === "ADMIN" ? (
            <div>
              <button type="button" className="primary-btn"
                onClick={() => toggleExitPopup(true)}
              >Offboard</button>
            </div>
          ) : ""}
        </div>
      </div>
      <Outlet/>
      {location.pathname === "/admin/offboarded" && (
       <div className='offboard-emp-container'>
        <div className="row">
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <p><b>Employee Name :</b><span>Raj Kishore</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>Web Development</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)}>Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay">
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                          <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
                <p><b>Employee Name :</b><span>Amit Raj</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>Web Development</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)}>Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay" style={{ top: '0' }}>
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                        <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
                <p><b>Employee Name :</b><span>Rekha Sinha</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>QA Testing</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)}>Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay" style={{ top: '0' }}>
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                        <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
                <p><b>Employee Name :</b><span>Radha Swami</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>Web Development</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)} >Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay" style={{ top: '0' }}>
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                        <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
                <p><b>Employee Name :</b><span>Raja Kumar</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>Web Development</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)}>Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay" style={{ top: '0' }}>
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                        <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="exit-card">
                <div className='exit-pic'>
                  <img
                    src={require("assets/img/profile-img.webp")}
                    alt="Profile"
                    className="profile-img"
                  /> </div>
                <p><b>Employee Name :</b><span>Swamini Gupta</span></p>
                <p><b>Employee ID :</b><span>523696</span></p>
                <p><b>Department:</b><span>WCS Support</span></p>
                <p><b>Last Working Day :</b><span>02-feb-2025</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} onClick={() => navigate('/admin/dashboard')}>Cancel</button>
                  <button className="primary-btn" onClick={() => setModalForAcceptingTerms(true)}>Acknowledge</button>
                </div>
                {isModalForAcceptingTerms && (
                  <div className="accept-pop-add-overlay" style={{ top: '0' }}>
                    <div className="popup">
                      <form>
                        <div className='user-input-icons'>
                           <p> Please accept if employee follow the {""}<a href="/admin/policies" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}}>company policies</a> </p>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                            <button className='primary-btn' onClick={() => navigate('/admin/offboarded/schedule-meeting', { state: { breadcrumbTrail } })}>Accept</button>
                            <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={() => setModalForAcceptingTerms(false)}>Cancel</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  )
}
